import React from 'react';
import {Modal} from 'antd';
import i18n from "../../../i18n";
import CreateCrossDock from '../../pages/consignor-page/create-cross-dock';

export default function CreateCrossDockModal({isShow, setIsShow}) {
  return (
    <Modal
      title={i18n.t('Создать заявку на кросс-докинг')}
      cancelText={i18n.t('main.buttons.close')}
      className="modal-window"
      align={null}
      visible={isShow}
      onCancel={() => {
        setIsShow(false);
      }}
      footer={[]}
    >
      <CreateCrossDock
        onCreate={() => {
          setIsShow(false)
        }}
      />
    </Modal>
  );

}
